import { render, staticRenderFns } from "./ExternalLinkPage.vue?vue&type=template&id=7e2c7d3b&scoped=true&"
import script from "./ExternalLinkPage.vue?vue&type=script&lang=js&"
export * from "./ExternalLinkPage.vue?vue&type=script&lang=js&"
import style0 from "./ExternalLinkPage.vue?vue&type=style&index=0&id=7e2c7d3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2c7d3b",
  null
  
)

export default component.exports